"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brentonico": {
    "39ad5b38": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "skipSearch": false
    }],
    "agglomerati-urbani-lera": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "32b033fc": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2abd3ade": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "skipSearch": false
    }],
    "fontechel": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edaa11f7": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "skipSearch": false
    }],
    "vigo": [{
      "hkey": "d2b9d49e",
      "slug": "brentonico",
      "name": "Brentonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;